import {
  Capability,
  CapabilityKeys,
  SelfServePlan,
  SelfServePlanFromApi,
} from '@hcs/types';

export const processSelfServePlan = (
  planRaw: SelfServePlanFromApi,
  capabilities: Partial<Record<CapabilityKeys, Capability>> | undefined,
): SelfServePlan => {
  const planCapabilities: Partial<Record<CapabilityKeys, Capability>> = {};
  const planProductDetails: SelfServePlan['product_details'] = {};
  if (capabilities) {
    planRaw.capabilities?.forEach((capabilityKey) => {
      const capability = capabilities[capabilityKey];
      if (capability) {
        planCapabilities[capabilityKey] = capability;
      }
    });
  }
  planRaw.product_details?.forEach((productDetail) => {
    if (productDetail.product_key) {
      planProductDetails[productDetail.product_key] = productDetail;
    }
  });
  const plan: SelfServePlan = {
    ...planRaw,
    verified_agent_plan:
      planRaw.tier_key?.startsWith('agent-') ||
      planRaw.visibility === 'verified-agent',
    planTierKey: planRaw.tier_key || '',
    product_details: planProductDetails,
    capabilities: planCapabilities,
  };
  return plan;
};
